import {ReactElement} from 'react'
import {Dots} from 'shared/ui/icons'
import {Beauty, Drink, Fashion, Food, Hobbies, Movies, Music, Sports, Travel} from './icon/icons'

export const getInterestIcon = (categoryName: string): ReactElement => {
  switch (categoryName) {
  case 'Food':
    return <Food />
  case 'Drink':
    return <Drink />
  case 'Music':
    return <Music />
  case 'Sports':
    return <Sports />
  case 'Travel':
    return <Travel />
  case 'Hobbies':
    return <Hobbies />
  case 'Fashion':
    return <Fashion />
  case 'Beauty':
    return <Beauty />
  case 'Movies':
    return <Movies />
  case 'Movies / TV':
    return <Movies />
  default:
    console.error('Unknown category interest name: ', categoryName)
    return <Dots />
  }
}
